<div class="fif-branch-container">
  <div class="header-row">
    <h2 class="page-title">Fif branch</h2>
    <button mat-raised-button color="primary" type="button" (click)="openCreate()">
      <mat-icon>add</mat-icon>
      Add Branch
    </button>
  </div>

  <mat-card class="content-card">
    <mat-card-content>
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [formControl]="searchControl" placeholder="Routing number, name or address" />
      </mat-form-field>

      <div class="table-area">
        <div *ngIf="isLoading" class="loading-overlay">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <table mat-table [dataSource]="branches" class="flat-table">
          <ng-container matColumnDef="dprn">
            <th mat-header-cell *matHeaderCellDef>Routing #</th>
            <td mat-cell *matCellDef="let row">{{ row.dprn }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Institution Name</th>
            <td mat-cell *matCellDef="let row">{{ row.name }}</td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>Address</th>
            <td mat-cell *matCellDef="let row">{{ row.address }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-col">Actions</th>
            <td mat-cell *matCellDef="let row" class="actions-col">
              <button mat-icon-button color="primary" matTooltip="Edit" (click)="openEdit(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Delete" (click)="onDelete(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <div *ngIf="!isLoading && branches.length === 0" class="empty-state">
          No branches found.
        </div>
      </div>

      <mat-paginator
        [length]="rowCount"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPage($event)"
        showFirstLastButtons>
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
